module.exports = __webpack_public_path__ + "static/media/companyLogo.2b771b68.png";